import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

// Default web app `-` needs to be converted to _
export function getAggSafeAppId (appId) {
    return String(appId).replace('-', '_');
}

function buildAppUsedFilterString ({ appId }) {
    const aggSafeAppId = getAggSafeAppId(appId);

    return `!isNil(metadata.auto_${aggSafeAppId}.lastvisit)`;
}

function buildAppNotUsedFilterString ({ appId }) {
    const aggSafeAppId = getAggSafeAppId(appId);

    return `isNil(metadata.auto_${aggSafeAppId}.lastvisit)`;
}

function buildAppUsedWithinLastFilterString ({ appId, count, granularity }) {
    const aggSafeAppId = getAggSafeAppId(appId);

    return `metadata.auto_${aggSafeAppId}.lastvisit>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

function buildAppUsedNotWithinLastFilterString ({ appId, count, granularity }) {
    const aggSafeAppId = getAggSafeAppId(appId);
    const field = `metadata.auto_${aggSafeAppId}.lastvisit`;

    return `(${field}>=now()||${field}<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

function buildAppUsedSinceFilterString ({ appId, value }) {
    const aggSafeAppId = getAggSafeAppId(appId);
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `metadata.auto_${aggSafeAppId}.lastvisit>=date("${date}")`;
}

function buildAppUsedBeforeFilterString ({ appId, value }) {
    const aggSafeAppId = getAggSafeAppId(appId);
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `metadata.auto_${aggSafeAppId}.firstvisit<=date("${date}")`;
}

function buildAppLastUsedBeforeFilterString ({ appId, value }) {
    const aggSafeAppId = getAggSafeAppId(appId);
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `metadata.auto_${aggSafeAppId}.lastvisit<=date("${date}")`;
}

function buildAppUsedBetweenFilterString ({ appId, first, last }) {
    const aggSafeAppId = getAggSafeAppId(appId);
    const field = `metadata.auto_${aggSafeAppId}.lastvisit`;
    const formattedFirst = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
    const formattedLast = moment(last, { ignoreTimeZone: true })
        .add(1, 'days')
        .format(DATE_FORMAT.iso);

    return `(${field}>=date("${formattedFirst}")&&${field}<date("${formattedLast}"))`;
}

export function parseApplicationUsageFilterPipeline ({ fact, used, ...params }) {
    let filterString;

    switch (fact) {
        case 'used':
            filterString = buildAppUsedFilterString(params);

            switch (used) {
                case 'before':
                    filterString += `&&${buildAppUsedBeforeFilterString(params)}`;
                    break;
                case 'since':
                    filterString += `&&${buildAppUsedSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildAppUsedWithinLastFilterString(params)}`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
        case 'lastused':
            filterString = buildAppUsedFilterString(params);
            switch (used) {
                case 'before':
                    filterString += `&&${buildAppLastUsedBeforeFilterString(params)}`;
                    break;
                case 'since':
                    filterString += `&&${buildAppUsedSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildAppUsedWithinLastFilterString(params)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildAppUsedNotWithinLastFilterString(params)}`;
                    break;
                case 'between':
                    filterString = buildAppUsedBetweenFilterString(params);
                    break;
            }
            break;
        case 'notused':
            filterString = buildAppNotUsedFilterString(params);

            switch (used) {
                case 'before':
                    filterString += `||!(${buildAppUsedBeforeFilterString(params)})`;
                    break;
                case 'since':
                    filterString += `||!(${buildAppUsedSinceFilterString(params)})`;
                    break;
                case 'withinLast':
                    filterString += `||!(${buildAppUsedWithinLastFilterString(params)})`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
